<template>
  <div class="text-start wrapper">
    <header>
      <div class="container py-5">
        <h1 class="heading mb-4">
          <slot name="title"></slot>
        </h1>
        <div id="No" class="container-scroll">
          <div
            class="d-flex flex-nowrap align-items-center justify-items-center"
          >
            <slot name="header"></slot>
          </div>
        </div>
      </div>
    </header>

    <div class="container px-3 pb-5">
      <div id="testing" class="container-scroll">
        <div class="course-list">
          <slot name="body"></slot>
        </div>
      </div>
    </div>

    <div class="container-fluid videos-bg p-3">
      <div class="container-scroll videos-wrapper">
        <div class="videos">
          <div class="row g-3">
            <div class="col-4">
              <video controls class="video">
                <source
                  src="@/assets/videos/NationalTeach.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
            <div class="col-4">
              <video controls class="video">
                <source
                  src="@/assets/videos/ScienceOverall.mp4"
                  type="video/mp4"
                />

                Your browser does not support the video tag.
              </video>
            </div>
            <div class="col-4">
              <video controls class="video">
                <source
                  src="@/assets/videos/MusicAndShare.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Footer :font_type="font_type" :path1="path1"></Footer>
</template>

<script>
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Footer,
  },

  data() {
    return {
      font_type: 1,
      path1: null,
    };
  },

  created() {
    this.$store.state.footer = false;
  },

  computed: {
    font_type() {
      return this.$store.state.font_type;
    },
  },

  watch: {
    $route(to, from) {
      var currentUrl = window.location.pathname;
      var Url = currentUrl.split("/");
      if (window.location.pathname.split("/")[1] == "") {
        this.path1 = true;
      } else {
        this.path1 = false;
      }
    },
  },

  beforeUnmount() {
    this.$store.state.footer = true;
  },
};
</script>

<style lang="scss" scoped>
.heading {
  text-transform: uppercase;
  color: var(--cus-secondary);
  font-weight: var(--cus-fw-semibold);
}

.btn {
  background-color: var(--cus-white);
  min-width: 120px;
  text-transform: uppercase;
  color: var(--cus-primary);
}

.label-bar {
  background-color: var(--cus-grey);
  border-bottom: 1px solid #808080;

  .label {
    font-size: var(--cus-fs-large);
    color: var(--cus-secondary-bold);
    font-weight: var(--cus-fw-semibold);
  }
}

.course-list {
  width: 600px;
  background-color: var(--cus-white);

  @include breakpoint(medium) {
    width: auto;
  }
}

.video {
  background-color: white;
  width: 100%;
  height: 300px;
  object-fit: fill;
}

.videos {
  width: 900px;

  @include breakpoint(small) {
    width: 1140px;
  }

  @include breakpoint(large) {
    width: 100%;
  }
}

.videos-bg {
  background-color: var(--cus-grey);
}

.container-scroll {
  overflow-x: auto;
  padding: 10px 0px;
}

.videos-wrapper {
  @include breakpoint(xlarge) {
    max-width: 1140px;
    margin: 0 auto;
  }

  @include breakpoint(xxlarge) {
    max-width: 1320px;
    margin: 0 auto;
  }
}

.wrapper {
  background-color: var(--cus-primary);
}

footer {
  background-image: url("@/assets/img/background.png");
  background-position: center;
  background-size: cover;
}

.nav-link {
  color: white;

  &:hover {
    color: rgb(200, 196, 196);
  }
}
</style>
